module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Performed Work","exportAsExcel":"Download Excel","exportAsCsv":"Download CSV","toaster":{"exportSizeError":"The file is too big. Please adjust the filter criteria."}},"hr":{"title":"Izvršeni rad","exportAsExcel":"Preuzmi Excel","exportAsCsv":"Preuzmi CSV","toaster":{"exportSizeError":"Datoteka je prevelika. Molimo podesite kriterije pretrage."}}}')
  delete Component.options._Ctor
}
